import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Ferie, HolidayView } from '@store/models';

@Injectable({ providedIn: 'root' })
export class HolidayService {
    constructor(private http: HttpClient) { }

    getHolidays(year: number): Observable<HolidayView[]> {
        const url = `[api]/HolidayView/[officeId]/${year}`;
        return this.http.get<HolidayView[]>(url);
    }

    saveFerie(ferie: Ferie) {
        const url = `[api]/model/ferie`;
        return this.http.post<Ferie>(url, ferie);
    }

}
